import React, { Suspense, useEffect, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { AnimatePresence } from "framer-motion";
import { Box } from "@mui/material";


import { selectSplashScreen } from "redux/slices/appSlice";
import { Redirect404, RedirectLoggedInUsers, RequireAuth } from "utilities/routes";
import useApiSnackbar from "utilities/snackbars/useApiSnackbar";

import SplashScreen from "components/splashScreen";
import ModuleLoader from "components/moduleLoader";
import RootErrorBoundary from "components/errorBoundary/rootErrorBoundary";

import Logout from 'views/logout'
import Promotion from 'views/promotion'
import VersionChangeModal from "components/modal/versionChangeModal";
import AnimatedLayout from "components/animationComponents/animatedLayout";

// Lazy elements
const Admission = React.lazy(() => import("./views/admission"));
const Admin = React.lazy(() => import("./views/admin"));
const User = React.lazy(() => import("./views/user"));
const Verification = React.lazy(() => import('./views/verification'));

const Fallback = ({ setSuspenseMounted }) => {
  useEffect(() => { setSuspenseMounted(true); return () => setSuspenseMounted(false) }, [setSuspenseMounted])
  return '';
};

const prepareKey = (pathname) => {
  if (pathname.includes('admin')) return 1
  if (pathname.includes('user')) return 2
  if (pathname.includes('admission')) return 3
  return pathname
}

function App() {
  // eslint-disable-next-line no-unused-vars
  const useSplashScreen = useSelector(selectSplashScreen)

  const [splashScreenActive, setSplashScreen] = useState(false);
  const [suspenseMounted, setSuspenseMounted] = useState(true)

  const location = useLocation();

  useEffect(() => setTimeout(() => setSplashScreen(false), 2100), []);

  useApiSnackbar()

  return (
    <Box sx={{ height: '100%' }}>
      <VersionChangeModal />
      <RootErrorBoundary>
        <AnimatePresence>
          <React.Fragment key={splashScreenActive}>
            <ModuleLoader suspenseMounted={suspenseMounted} />
            {splashScreenActive
              ? <SplashScreen suspenseMounted={suspenseMounted} />
              : (
                < Suspense fallback={<Fallback setSuspenseMounted={setSuspenseMounted} />}>
                  <AnimatePresence exitBeforeEnter initial={false}>
                    <Routes location={location} key={prepareKey(location.pathname)}>
                      <Route path="/admin/*" element={<RequireAuth><Admin /></RequireAuth>} />
                      <Route path="/user/*" element={<RequireAuth><User /></RequireAuth>} />
                      <Route path="/admission/*" element={<RedirectLoggedInUsers><Admission /></RedirectLoggedInUsers>} />
                      <Route path="/promotion" element={<Promotion />} />
                      <Route path="/logout" element={<Logout />} />
                      <Route path="/verification/:token" element={<AnimatedLayout><Verification /></AnimatedLayout>} />
                      <Route path="*" element={<Redirect404 />} />
                    </Routes>
                  </AnimatePresence>
                </Suspense>
              )}
          </React.Fragment>
        </AnimatePresence>
      </RootErrorBoundary>
    </Box >
  );
}

export default App;